import { t } from './i18n.ts';

/** Duración de la intro (ms): el título y "MOBA" ya han caído y brillado. */
const INTRO_MS = 3600;

/**
 * Intro de carga (`#splash`, markup en index.html, animación en CSS): rayos y
 * destello, el emblema que se clava, MELEE cae letra a letra con impacto y
 * MOBA entra debajo; la barra de carga va abajo. Se va con un destello blanco
 * cuando la carga terminó Y la intro llegó al final (un clic o una tecla la
 * adelantan, pero nunca antes de que cargue).
 */
export class Splash {
  private readonly root = document.getElementById('splash');
  private readonly fill = this.root?.querySelector<HTMLElement>('.splash-fill');
  private readonly label = this.root?.querySelector<HTMLElement>('.splash-label');
  private readonly startedAt = performance.now();
  private skipped = false;
  private done = false;

  constructor() {
    if (!this.root) return;
    if (this.label) this.label.textContent = t('Cargando modelos…');
    const skip = () => {
      if (this.skipped || !this.root) return;
      this.skipped = true;
      this.root.classList.add('skip');
    };
    this.root.addEventListener('pointerdown', skip);
    window.addEventListener('keydown', skip, { once: true });
  }

  setProgress(fraction: number, label: string): void {
    if (this.fill) this.fill.style.width = `${Math.round(Math.max(0, Math.min(1, fraction)) * 100)}%`;
    if (this.label) this.label.textContent = label;
  }

  /** Carga lista: espera al final de la intro (o al salto) y sale con un destello. */
  async finish(): Promise<void> {
    if (!this.root || this.done) return;
    this.done = true;
    this.setProgress(1, t('Listo'));
    this.root.classList.add('ready');
    while (!this.skipped && performance.now() - this.startedAt < INTRO_MS) {
      await new Promise((resolve) => window.setTimeout(resolve, 50));
    }
    this.leave();
  }

  /** Error de carga: se quita para que el menú muestre el mensaje. */
  fail(): void {
    if (!this.root || this.done) return;
    this.done = true;
    this.leave();
  }

  private leave(): void {
    const root = this.root;
    if (!root) return;
    root.classList.add('leaving');
    window.setTimeout(() => root.remove(), 900);
  }
}
